import { HelpFrame } from "@/components/help/help-frame"
import { SiteShell } from "@/components/layout/site-shell"
import { Skeleton } from "@anysola/ui/skeleton"

function SkeletonCard({ rows }: { rows: number }) {
  return (
    <div className="min-w-0 rounded-surface bg-card p-2">
      <div className="flex items-center gap-3 px-3 pt-2 pb-3">
        <Skeleton className="size-9 rounded-xl" />
        <Skeleton className="h-5 w-40" />
      </div>
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="px-3 py-3">
          <Skeleton className="h-4 w-3/5" />
          <Skeleton className="mt-1.5 h-3.5 w-11/12" />
        </div>
      ))}
    </div>
  )
}

/** The search field, then the section cards: the frame of `routes/help/index.tsx`. */
export function HelpLoading() {
  return (
    <SiteShell>
      <HelpFrame>
        <Skeleton className="h-14 rounded-surface" />
        <div className="mt-6 grid gap-3 xl:grid-cols-2">
          <SkeletonCard rows={3} />
          <SkeletonCard rows={2} />
        </div>
      </HelpFrame>
    </SiteShell>
  )
}
